<ng-container *transloco="let transloco">
  <div class="relative w-full h-full flex flex-col bg-white">
    <div class="w-full flex justify-center items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
        <!-- 초록색 동그라미 -->
        <circle cx="50" cy="50" r="48" fill="#4CAF50" stroke="#4CAF50" stroke-width="2" />

        <!-- 하얀색 체크 아이콘 -->
        <path fill="none" stroke="#FFFFFF" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" d="M30 50 L45 65 L70 35" />
      </svg>
    </div>

    <p class="mt-6 w-full flex justify-center items-center text-center text-[16px] font-[500] break-keep">{{ 'Great! A password reset email has been sent to your inbox. Please click the link in the email to create a new password.' | transloco }}</p>

    <div class="flex-none mt-12 relative w-full h-[55px] flex flex-row gap-[14px]">
      <button class="w-full h-full flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickCancel()">{{ 'Back' | transloco }}</button>
    </div>
  </div>
</ng-container>
